/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'



export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

// permission details
export async function loadDataCopyDetails(searchvalue) {
  // let unassigned
  if (searchvalue) {
    return await api

      .post(`/get-data-copy-scheduling-deleted`, searchvalue)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get-data-copy-scheduling-deleted`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }

  // return unassigned
}




//Data Link section
export function loadDataLinkDetails(id) {
  return api
    .post(`/get_all_naslink_data`, id)   
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function uploadQcDetails(qcDetails) {

  try {
    const response = await api.post(`/add_qc_uploadLink`, qcDetails)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
//Data Link section
export function deleteStatusDetails(deleteStatus) {
  return api
    .post(`/update_operation_delete_status`,deleteStatus)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadDataCopyDetails,
  //Nas Link
  loadDataLinkDetails,
  uploadQcDetails,
  deleteStatusDetails
}

export default remotes
